"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardObjectImpl = void 0;
/**
 * Implementation of the dashboard objects - the zones in a dashboard.
 * This does not follow the Impl pattern as it is just a property bag.
 */
class DashboardObjectImpl {
    constructor(_dashboardImpl, _type, _position, _size, _worksheetImpl, _name, _isFloating, _isVisible, _id, _fieldId) {
        this._dashboardImpl = _dashboardImpl;
        this._type = _type;
        this._position = _position;
        this._size = _size;
        this._worksheetImpl = _worksheetImpl;
        this._name = _name;
        this._isFloating = _isFloating;
        this._isVisible = _isVisible;
        this._id = _id;
        this._fieldId = _fieldId;
    }
    get dashboardImpl() {
        return this._dashboardImpl;
    }
    get type() {
        return this._type;
    }
    get position() {
        return this._position;
    }
    get size() {
        return this._size;
    }
    get worksheetImpl() {
        return this._worksheetImpl;
    }
    get name() {
        return this._name;
    }
    get isFloating() {
        return this._isFloating;
    }
    get isVisible() {
        return this._isVisible;
    }
    get id() {
        return this._id;
    }
    get fieldId() {
        return this._fieldId;
    }
}
exports.DashboardObjectImpl = DashboardObjectImpl;
//# sourceMappingURL=DashboardObjectImpl.js.map